import { track } from './track.js';

/**
 * Erro do app que a pessoa viu (tela ou camada que falhou, erro solto no
 * aparelho). Vai só o lugar, o tipo e o começo da mensagem técnica, nunca
 * conteúdo de conversa. No máximo alguns por abertura do app, para um erro em
 * laço não virar enxurrada.
 */
const MAX_PER_SESSION = 6;
let sent = 0;
const seen = new Set<string>();

function clean(text: string): string {
  // Sem endereços, identificadores ou números longos: só o formato do erro.
  return text
    .replace(/https?:\/\/\S+/g, '(url)')
    .replace(/[0-9a-f]{8}-[0-9a-f-]{27,}/gi, '(id)')
    .replace(/\d{5,}/g, '(n)')
    .slice(0, 60);
}

export function reportClientError(where: string, error: unknown): void {
  try {
    const name = error instanceof Error ? error.name : typeof error;
    const message = clean(error instanceof Error ? error.message : String(error));
    const key = `${where}|${name}|${message}`;
    if (seen.has(key) || sent >= MAX_PER_SESSION) return;
    seen.add(key);
    sent += 1;
    const frame =
      error instanceof Error && error.stack
        ? clean(error.stack.split('\n').slice(1, 2).join('').trim())
        : '';
    track('client_error', {
      where: where.slice(0, 60),
      kind: name.slice(0, 60),
      message,
      ...(frame ? { frame } : {}),
      route: clean(window.location.pathname),
    });
  } catch {
    /* relatar erro nunca pode causar outro */
  }
}

/** Erros que escapam do React (promessa sem tratamento, script que falha). */
export function watchClientErrors(): void {
  window.addEventListener('error', (event) => {
    // Falha de imagem ou recurso não é erro de código.
    if (event.error) reportClientError('janela', event.error);
  });
  // Promessa sem tratamento é comum em biblioteca (rede que cai): no máximo duas por abertura.
  let rejections = 0;
  window.addEventListener('unhandledrejection', (event) => {
    rejections += 1;
    if (rejections <= 2) reportClientError('promessa', event.reason);
  });
}
